module.exports = {
    getCurrentPolicy: defaultPolicyDetails => {
        if (typeof window !== 'undefined' && window.consentPolicyManager) {
            return window.consentPolicyManager.getCurrentConsentPolicy()
        }
        return defaultPolicyDetails
    }
}
